// hooks
import useSubscriptions from 'src/hooks/useSubscriptions';
import { StyledAccountBadge } from './styles';
import { DoubleCubeIcon } from 'src/theme/overrides/CustomIcons';
import { AppTooltip } from 'src/components';
import { Chip } from '@mui/material';
import { IconLock } from 'src/libraries/icons';
// ----------------------------------------------------------------------

export const AccountBadge = () => {
  const { userOnFreePlan, trialExpiresMessage, isPremiumUser, activateYourPlansMessage } =
    useSubscriptions();

  if (isPremiumUser) {
    return <StyledAccountBadge size="small" avatar={<DoubleCubeIcon />} label="Premium" color="secondary" />
  } else if (userOnFreePlan) {
    return <StyledAccountBadge label="Free" size="small" />;
  } else if (isPremiumUser) {
    return <StyledAccountBadge size="small" avatar={<DoubleCubeIcon />} label="Premium" color="secondary" />;
  } else if (trialExpiresMessage) {
    return <StyledAccountBadge label="Trial" color="primary" variant="outlined" size="small" />;
  } else if (activateYourPlansMessage) {
    return (
      <StyledAccountBadge
        size="small"
        avatar={<DoubleCubeIcon />}
        label="Subscribe today"
        color="secondary"
      />
    );
  } else {
    return null;
  }
}

interface FeatureBadgeProps {
  status?: 'trial' | 'inactive';
  small?: boolean;
  label?: string;
}

export const FeatureBadge = ({ status = 'trial', small, label }: FeatureBadgeProps) => {
  return (
    <AppTooltip
      disableHoverListener = {status === 'trial'}
      placement="top"
      title="Upgrade your plan to view your premium features"
    >
      <StyledAccountBadge
        small={small?.toString()}
        avatar={<DoubleCubeIcon />}
        label={label ? label : small ? '' : status === 'trial' ? 'Premium feature' : 'Subscribe today'}
        variant={'filled'}
        color={'secondary'}
      />
    </AppTooltip>
  )
}

export const FeatureBadgeV2 = ({ label }: { label: string }) => {
  return (
    <Chip
      icon={<IconLock />}
      label={label}
      variant="outlined"
      sx={{
        border: theme => `1px solid ${theme.palette.text.primary}`,
        backgroundColor: 'transparent',
        '& .MuiChip-icon': { height: 16 },
        width: 'fit-content',
        '& .MuiChip-label': { paddingLeft: 0.5 }
      }}
    />
  );
};
